var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.795,
    height: 10.465,
    viewBox: "0 0 11.795 10.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ed555a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.3,12.955h.467a.2.2,0,0,1,.214.214l-.056,2.853a.2.2,0,0,1-.207.212H8.355a.188.188,0,0,1-.207-.213l-.056-2.849A.189.189,0,0,1,8.3,12.955Zm.516,3.834H8.229a.172.172,0,0,0-.186.193v.509a.172.172,0,0,0,.186.193h.586a.177.177,0,0,0,.192-.193v-.509A.177.177,0,0,0,8.816,16.79Zm5.619,1.7a1.567,1.567,0,0,1-.758,1.27l-.1.049H3.5l-.1-.047a1.524,1.524,0,0,1-.763-1.277l0-.134L7.681,9.621l.084-.064A1.491,1.491,0,0,1,9.3,9.548l.093.066,5.044,8.737Zm-1.064.1-4.734-8.2a.828.828,0,0,0-.2,0L3.7,18.59a.845.845,0,0,0,.1.178H13.27A.945.945,0,0,0,13.37,18.585Z",
    transform: "translate(-2.639 -9.341)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9b3547b3.svg";
export { ForwardRef as ReactComponent };